import { MdbStickyDirective } from './sticky-content.directive';
import { MdbStickyModule } from './sticky-content.module';
export { MdbStickyDirective, MdbStickyModule };



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/libs/mdbootstrap/typescripts/pro/sticky-content/index.ts